globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "@emotion/styled";

/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useAuthContext } from '../context';
import { useRouter } from 'next/router';
import { Redirect } from './redirect';
import { useIsEmployerAnAdmin, useEmployerUserInformationLoadingState } from '../hook';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var COLLABORATOR_ROLE_KEYS = {
  ADMIN: 'admin_employer_user',
  BASE: 'base_employer_user'
};
var privatePaths = ['/worker/', '/employer/', '/referral/', '/impostazioni', '/profilo', '/candidature', '/v2/employer/'];
var redirectLocation = '/login';
export var AuthGuard = function AuthGuard(_ref) {
  var children = _ref.children,
      loader = _ref.loader;
  var router = useRouter();
  var authContext = useAuthContext();
  var isAdminEmployer = useIsEmployerAnAdmin();
  var isEmployerInfoLoading = useEmployerUserInformationLoadingState();

  if (authContext) {
    var _router$query, _router$query$token;

    var userData = authContext.user,
        isReady = authContext.isReady,
        jwt = authContext.jwt,
        isAuthenticated = authContext.isAuthenticated,
        logoutRedirect = authContext.logoutRedirect;
    var query = router.query,
        asPath = router.asPath;
    var currentPath = router.asPath;
    var token = (router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : (_router$query$token = _router$query['token']) === null || _router$query$token === void 0 ? void 0 : _router$query$token.toString()) || ''; // Check if the URL includes a "?"

    var indexOfQuestionMark = currentPath.indexOf('?'); // Determine the base path based on whether there's a query string

    var basepath = indexOfQuestionMark >= 0 ? currentPath.slice(0, indexOfQuestionMark) : currentPath;
    var queryParams = '';

    if (query) {
      queryParams = Object.keys(query).map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(query[key]));
      }).join('&');
    }

    var currentUrl = "".concat(basepath).concat(queryParams ? "?".concat(queryParams) : '');
    var isPrivate = privatePaths.filter(function (privatePath) {
      return basepath.startsWith(privatePath);
    }).length > 0;
    var isEmployer = !!userData && (userData.type === 'employer' || (userData === null || userData === void 0 ? void 0 : userData.type) === 'employer_contact');

    if (logoutRedirect && !isAuthenticated) {
      return /*#__PURE__*/_jsx(Redirect, {
        to: isPrivate ? '/' : currentUrl,
        refresh: true
      });
    }

    if ((!isReady || isEmployer && isEmployerInfoLoading) && isPrivate) return /*#__PURE__*/_jsx(ScreenSpinnerWrapper, {
      children: loader
    }); // check if private route

    if (isPrivate) {
      // private routes
      if (!jwt && isReady && !logoutRedirect) return /*#__PURE__*/_jsx(Redirect, {
        to: "".concat(redirectLocation, "?redirect_url=").concat(currentUrl)
      });

      if (jwt) {
        if (asPath.startsWith('/worker/') || asPath.startsWith('/profilo') || asPath.startsWith('/candidature')) {
          if (userData && (userData.type === 'employer' || (userData === null || userData === void 0 ? void 0 : userData.type) === 'employer_contact')) return /*#__PURE__*/_jsx(Redirect, {
            to: "/v2/employer/homepage"
          });else if (userData && userData.type === 'ambassador') return /*#__PURE__*/_jsx(Redirect, {
            to: "/challenge-wom/posizioni"
          });else if (userData && userData.type === 'lead') return /*#__PURE__*/_jsx(Redirect, {
            to: "/candidati"
          });
        }

        if (asPath.startsWith('/employer/') || asPath.startsWith('/v2/employer/')) {
          if (userData && userData.type === 'worker') return /*#__PURE__*/_jsx(Redirect, {
            to: "/profilo"
          });else if (userData && userData.type === 'ambassador') return /*#__PURE__*/_jsx(Redirect, {
            to: "/challenge-wom/posizioni"
          });else if (userData && userData.type === 'lead') return /*#__PURE__*/_jsx(Redirect, {
            to: "/"
          });else if (userData && asPath.includes('payments-and-invoices') && !isAdminEmployer) return /*#__PURE__*/_jsx(Redirect, {
            to: "/"
          });else return /*#__PURE__*/_jsx(_Fragment, {
            children: children
          });
        } // if (asPath.startsWith('/profilo') && userData && userData.type === 'lead') return <Redirect to="/candidati" />;


        return /*#__PURE__*/_jsx(_Fragment, {
          children: children
        });
      }
    } else {
      if (asPath === '/' || asPath === '/login') {
        if (userData && (userData.type === 'employer' || (userData === null || userData === void 0 ? void 0 : userData.type) === 'employer_contact')) return /*#__PURE__*/_jsx(Redirect, {
          to: "/v2/employer/homepage"
        });
      }
    } // public routes


    if (asPath.startsWith('/reset-password') && jwt && isReady) return /*#__PURE__*/_jsx(Redirect, {
      to: "/profilo"
    });

    if (asPath.startsWith('/login') || asPath.startsWith('/signup')) {
      if (jwt && isReady && isAuthenticated && !token) {
        var userType = userData === null || userData === void 0 ? void 0 : userData.type;
        if (userType === 'employer' || userType === 'employer_contact') return /*#__PURE__*/_jsx(Redirect, {
          to: '/v2/employer/homepage'
        });else if (query["redirect_url"]) return /*#__PURE__*/_jsx(Redirect, {
          to: query["redirect_url"].toString()
        });else if (query["redirectTo"]) return /*#__PURE__*/_jsx(Redirect, {
          to: query["redirectTo"].toString()
        });else if (userType === 'worker') return /*#__PURE__*/_jsx(Redirect, {
          to: '/profilo'
        });else if (userType === 'ambassador') return /*#__PURE__*/_jsx(Redirect, {
          to: '/challenge-wom/posizioni'
        });else return /*#__PURE__*/_jsx(Redirect, {
          to: '/'
        });
      }
    }

    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
};

var ScreenSpinnerWrapper = _styled.div({
  "display": "flex",
  "height": "100vh",
  "width": "100vw",
  "alignItems": "center",
  "justifyContent": "center"
});